// searchReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchString: '',
  confirmedSearchString: '',
  nonSearchString1: '',
  nonSearchString2: '',
  searchStringClearButton: false,
  nonSearchStringClearButton: false,
  searchScopeList: [],
  searchScopeListItemSelected: 67,
  showRemaining: false,
  searchCriteriaListItem: null,
  searchResultVerseList: { ResultTotal: -1, VerseList: [] },
  pageNumberVerseSearch: 0,
  searchHttpPostData: null,
  open3: false,
  verseListItem: {},
  searchStringPlaceHolder: '',
  nonSearchString1PlaceHolder: '',
  nonSearchString2PlaceHolder: '',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchString(state, action) {
      state.searchString = action.payload;
    },
    setConfirmedSearchString(state, action) {
      state.confirmedSearchString = action.payload;
    },
    setNonSearchString1(state, action) {
      state.nonSearchString1 = action.payload;
    },
    setNonSearchString2(state, action) {
      state.nonSearchString2 = action.payload;
    },
    setSearchStringClearButton(state, action) {
      state.searchStringClearButton = action.payload;
    },
    setNonSearchStringClearButton(state, action) {
      state.nonSearchStringClearButton = action.payload;
    },
    setSearchScopeList(state, action) {
      state.searchScopeList = action.payload;
    },
    setSearchScopeListItemSelected(state, action) {
      state.searchScopeListItemSelected = action.payload;
    },
    setShowRemaining(state, action) {
      state.showRemaining = action.payload;
    },
    setSearchCriteriaListItem(state, action) {
      state.searchCriteriaListItem = action.payload;
    },
    setSearchResultVerseList(state, action) {
      state.searchResultVerseList = action.payload;
    },
    setPageNumberVerseSearch(state, action) {
      state.pageNumberVerseSearch = action.payload;
    },
    setSearchHttpPostData(state, action) {
      state.searchHttpPostData = action.payload;
    },
    setOpen3(state, action) {
      state.open3 = action.payload;
    },
    setVerseListItem(state, action) {
      state.verseListItem = action.payload;
    },
    setSearchStringPlaceHolder(state, action) {
      state.searchStringPlaceHolder = action.payload;
    },
    setNonSearchString1PlaceHolder(state, action) {
      state.nonSearchString1PlaceHolder = action.payload;
    },
    setNonSearchString2PlaceHolder(state, action) {
      state.nonSearchString2PlaceHolder = action.payload;
    },
    reset4Search() {
      return initialState;
    },
  },
});

export const { setSearchString, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setShowRemaining, setSearchCriteriaListItem, setSearchResultVerseList, setPageNumberVerseSearch, setSearchHttpPostData, setOpen3, setVerseListItem, setSearchStringPlaceHolder, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, reset4Search } = searchSlice.actions;
export default searchSlice.reducer;
// const initialState = {
//   searchString: '',
//   confirmedSearchString: '',
//   nonSearchString1: '',
//   nonSearchString2: '',
//   searchStringClearButton: false,
//   nonSearchStringClearButton: false,
//   searchScopeList: [],
//   searchScopeListItemSelected: 67,
//   showRemaining: false,
//   searchCriteriaListItem: null,
//   searchResultVerseList: {ResultTotal: -1, VerseList: []},
//   pageNumberVerseSearch: 0,
//   searchHttpPostData: null,
//   //loading4Search: false,
//   open3: false,
//   verseListItem: {},
//   searchStringPlaceHolder: '',
//   nonSearchString1PlaceHolder: '',
//   nonSearchString2PlaceHolder: '',
// };

// export default function verseSearchReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setSearchString':
//       return {
//         ...state,
//         searchString: action.payload,
//       };
//     case 'setConfirmedSearchString':
//       return {
//         ...state,
//         confirmedSearchString: action.payload,
//       };
//     case 'setNonSearchString1':
//       return {
//         ...state,
//         nonSearchString1: action.payload,
//       };
//     case 'setNonSearchString2':
//       return {
//         ...state,
//         nonSearchString2: action.payload,
//       };
//     case 'setSearchStringClearButton':
//       return {
//         ...state,
//         searchStringClearButton: action.payload,
//       };
//     case 'setNonSearchStringClearButton':
//       return {
//         ...state,
//         nonSearchStringClearButton: action.payload,
//       };
//     case 'setSearchScopeList':
//       return {
//         ...state,
//         searchScopeList: action.payload,
//       };
//     case 'setSearchScopeListItemSelected':
//       return {
//         ...state,
//         searchScopeListItemSelected: action.payload,
//       };
//     case 'setShowRemaining':
//       return {
//         ...state,
//         showRemaining: action.payload,
//       };
//     case 'setSearchCriteriaListItem':
//       return {
//         ...state,
//         searchCriteriaListItem: action.payload,
//       };
//     case 'setSearchResultVerseList':
//       return {
//         ...state,
//         searchResultVerseList: action.payload,
//       };
//     case 'setPageNumberVerseSearch':
//       return {
//         ...state,
//         pageNumberVerseSearch: action.payload,
//       };
//     case 'setSearchHttpPostData':
//       return {
//         ...state,
//         searchHttpPostData: action.payload,
//       };
//     // case 'setLoading4Search':
//     //   return {
//     //     ...state,
//     //     loading4Search: action.payload,
//     //   };
//     case 'setOpen3':
//       return {
//         ...state,
//         open3: action.payload, // Update the selected book
//       };
//     case 'setVerseListItem':
//       return {
//         ...state,
//         verseListItem: action.payload, // Update the selected book
//       };  
//     case 'setSearchStringPlaceHolder':
//       return {
//         ...state,
//         searchStringPlaceHolder: action.payload, // Update the selected book
//       }; 
//     case 'setNonSearchString1PlaceHolder':
//       return {
//         ...state,
//         nonSearchString1PlaceHolder: action.payload, // Update the selected book
//       };      
//     case 'setNonSearchString2PlaceHolder':
//       return {
//         ...state,
//         nonSearchString2PlaceHolder: action.payload, // Update the selected book
//       };              
//     case 'reset4Search':
//       return initialState;        
//     default:
//       return state;
//   }
// }

// export const setSearchString = (e) => ({
//   type: 'setSearchString',
//   payload: e,
// });

// export const setConfirmedSearchString = (e) => ({
//   type: 'setConfirmedSearchString',
//   payload: e,
// });

// export const setNonSearchString1 = (e) => ({
//   type: 'setNonSearchString1',
//   payload: e,
// });

// export const setNonSearchString2 = (e) => ({
//   type: 'setNonSearchString2',
//   payload: e,
// });

// export const setSearchStringClearButton = (e) => ({
//   type: 'setSearchStringClearButton',
//   payload: e,
// });

// export const setNonSearchStringClearButton = (e) => ({
//   type: 'setNonSearchStringClearButton',
//   payload: e,
// });

// export const setSearchScopeList = (e) => ({
//   type: 'setSearchScopeList',
//   payload: e,
// });

// export const setSearchScopeListItemSelected = (e) => ({
//   type: 'setSearchScopeListItemSelected',
//   payload: e,
// });

// export const setShowRemaining = (e) => ({
//   type: 'setShowRemaining',
//   payload: e,
// });

// export const setSearchCriteriaListItem = (e) => ({
//   type: 'setSearchCriteriaListItem',
//   payload: e,
// });

// export const setSearchResultVerseList = (e) => ({
//   type: 'setSearchResultVerseList',
//   payload: e,
// });

// export const setPageNumberVerseSearch = (e) => ({
//   type: 'setPageNumberVerseSearch',
//   payload: e,
// });

// export const setSearchHttpPostData = (e) => ({
//   type: 'setSearchHttpPostData',
//   payload: e,
// });

// // export const setLoading4Search = (e) => ({
// //   type: 'setLoading4Search',
// //   payload: e,
// // });

// export const setOpen3 = (e) => ({
//   type: 'setOpen3',
//   payload: e,
// });

// export const setVerseListItem = (e) => ({
//   type: 'setVerseListItem',
//   payload: e,
// });

// export const setSearchStringPlaceHolder = (e) => ({
//   type: 'setSearchStringPlaceHolder',
//   payload: e,
// });

// export const setNonSearchString1PlaceHolder = (e) => ({
//   type: 'setNonSearchString1PlaceHolder',
//   payload: e,
// });

// export const setNonSearchString2PlaceHolder = (e) => ({
//   type: 'setNonSearchString2PlaceHolder',
//   payload: e,
// });

// export const reset4Search  = (e) => ({
//   type: 'reset4Search',
//   payload: e,
// });